import React from 'react';

const InfoOutline = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.9993 20.3346C16.6017 20.3346 20.3326 16.6037 20.3326 12.0013C20.3326 7.39893 16.6017 3.66797 11.9993 3.66797C7.39691 3.66797 3.66595 7.39893 3.66595 12.0013C3.66595 16.6037 7.39691 20.3346 11.9993 20.3346Z",
      fill: "#17191C"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.8197 7.67188V9.14223H11.1812V7.67188H12.8197ZM9.79492 10.5285H12.8197V14.9395H14.206V16.5781H11.1812V12.167H9.79492V10.5285Z",
      fill: "currentColor"
    }
  )
);
InfoOutline.displayName = "Icons.InfoOutline";

export { InfoOutline };
//# sourceMappingURL=InfoOutline.js.map
